import { useEffect } from 'react';

const STORAGE_KEY = 'skjeta_ensure_daily_check';

// Self-healing safety net for the daily meme/fact/news and monthly
// Skjetaperson nomination. Vercel Cron is supposed to cover this, but
// this project is on the Hobby plan (max 2 scheduled cron jobs, and no
// execution history is visible in the dashboard to confirm a run
// actually happened). Instead of trusting that blindly, ping a
// lightweight endpoint once per day per visitor that checks what's
// actually missing and generates it - so a missed cron run gets caught
// by the first real visitor of the day instead of the site quietly
// going stale.
export function useEnsureDailyContent() {
  useEffect(() => {
    const today = new Date().toISOString().split('T')[0];
    try {
      if (localStorage.getItem(STORAGE_KEY) === today) return;
      localStorage.setItem(STORAGE_KEY, today);
    } catch {
      // localStorage unavailable (private mode etc) - fine to skip the
      // once-a-day gate, worst case is an extra ping.
    }

    fetch('/api/ensure-daily', { method: 'POST' }).catch(() => {
      // Best-effort - a failed ping just means we try again on the next
      // visit (or the real cron catches it in the meantime).
    });
  }, []);
}
